/* BVO Maison — product image viewer.

   Loaded by sections/main-product.liquid only: nothing outside the product page
   needs it, and the shared bvo.js stays the file every template pays for. */
(function () {
  'use strict';

  /* Shopify serves every rendition off one URL, so a size is a query-string
     rewrite: 1920 for the viewer, 160 for its thumb strip. */
  function atWidth(url, w) {
    if (!url) return '';
    if (url.indexOf('width=') > -1) return url.replace(/width=\d+/, 'width=' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function fileOf(url) {
    return String(url || '').split('?')[0].split('/').pop();
  }
  /* one asset, every rendition: the measurement cache in bvo.js keys the same way */
  function keyOf(url) {
    return String(url || '').split('?')[0];
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    /* ---------- full-resolution image viewer ----------
       The photography is 1920 wide and the column shows about 700, so most of the
       detail a frame is judged on never reaches the screen. The viewer serves the
       1920 rendition and magnifies from there.

       The image list is read out of the thumb row at open time and never cached:
       the variant picker rebuilds that row on every colour change, so the viewer
       always holds the colourway currently on screen rather than the one the page
       was rendered with. */
    var zoomRoot = document.querySelector('[data-zoom-root]');
    if (zoomRoot) {
      var zDialog = zoomRoot.querySelector('[data-zoom-dialog]');
      var zStage = zoomRoot.querySelector('[data-zoom-stage]');
      var zImg = zoomRoot.querySelector('[data-zoom-image]');
      /* The crop window the shot is shown through. Built here rather than in
         Liquid so the section markup stays one <img> and a cached render of it
         still works: the viewer owns the geometry either way. */
      var zFrame = zoomRoot.querySelector('[data-zoom-frame]');
      if (zImg && !zFrame) {
        zFrame = document.createElement('div');
        zFrame.className = 'zoomer__frame';
        zFrame.setAttribute('data-zoom-frame', '');
        zImg.parentNode.insertBefore(zFrame, zImg);
        zFrame.appendChild(zImg);
      }
      var zThumbs = zoomRoot.querySelector('[data-zoom-thumbs]');
      var zCount = zoomRoot.querySelector('[data-zoom-count]');
      var zPrev = zoomRoot.querySelector('[data-zoom-prev]');
      var zNext = zoomRoot.querySelector('[data-zoom-next]');
      var zToggle = zoomRoot.querySelector('[data-zoom-toggle]');
      var zToggleLabel = zoomRoot.querySelector('[data-zoom-toggle-label]');
      var zClose = zoomRoot.querySelector('[data-zoom-close]');
      var zScrim = zoomRoot.querySelector('[data-zoom-scrim]');

      var items = [];
      var index = 0;
      var magnified = false;
      var scale = 1;
      var opener = null;
      var baseRect = null;                 /* the crop window before any transform */
      var panX = 0.5, panY = 0.5, panFrame = 0;
      var dragging = false, dragMoved = false, lastX = 0, lastY = 0;
      var padded = false;
      var cropSrcW = 0;                    /* the crop's width in source pixels */

      /* the artwork's own margin, as a share of its long side. Small enough to
         read as a mount rather than a border, large enough that the frame is
         never touching the edge of the panel. */
      var MARGIN = 0.06;
      var boxes = {};                      /* asset URL, query stripped -> box | null */

      function clamp01(n) { return n < 0 ? 0 : n > 1 ? 1 : n; }

      /* ---- optical centring, by cropping ----
         The page can translate a badly framed shot inside its tile because the
         tile carries --shot: ground slides out of view and identical ground
         replaces it. On the scrim there is no such cover — the grey rectangle
         is the thing being looked at, and translating it just moves a lopsided
         panel around. So here the correction is a crop instead: the artwork's
         measured box, grown by one uniform margin, is the panel, and the panel
         is centred. What is left is even ground on all four sides.

         The crop is allowed past the edge of the canvas — several views are
         framed with the frame bleeding off the top — and the shortfall is
         painted by the window's own background. That is exact rather than
         approximate: the ground baked into this photography is #F2F2F2 to the
         pixel, which is what --shot is.

         Magnification scales the window, not the image inside it, so the two
         compose: the crop decides what can be reached and the scale decides
         how close, and no gesture can pan onto ground the crop removed. */
      function paint() {
        zFrame.style.transform = 'translate(-50%, -50%)' + (magnified ? ' scale(' + scale + ')' : '');
      }

      /* Source pixels throughout: the box arrives as fractions of the canvas,
         so one measurement serves the 1100 on the page and the 1920 here. */
      function cropOf(nw, nh) {
        var whole = { x0: 0, y0: 0, x1: nw, y1: nh };
        var box = boxes[keyOf(zImg.currentSrc || zImg.src)];
        if (!box) return whole;
        var x0 = box.x0 * nw, x1 = box.x1 * nw;
        var y0 = box.y0 * nh, y1 = box.y1 * nh;
        var aw = x1 - x0, ah = y1 - y0;
        /* a read that found almost nothing is noise, not artwork: show the
           canvas as delivered rather than a crop of a stray dark pixel */
        if (!(aw > nw * 0.05) || !(ah > nh * 0.05)) return whole;
        var m = MARGIN * Math.max(aw, ah);
        return { x0: x0 - m, y0: y0 - m, x1: x1 + m, y1: y1 + m };
      }

      /* the window is sized to the crop and the image is hung inside it by
         negative offsets, so the panel is exactly what the crop describes */
      function layout() {
        if (!zImg.complete) return;
        var nw = zImg.naturalWidth, nh = zImg.naturalHeight;
        if (!nw || !nh) return;
        var sw = zStage.clientWidth, sh = zStage.clientHeight;
        if (!sw || !sh) return;

        var c = cropOf(nw, nh);
        var cw = c.x1 - c.x0, ch = c.y1 - c.y0;
        if (!(cw > 0) || !(ch > 0)) return;

        /* Never past 1:1 — the source runs out before the stage does. The
           stage is a fixed size but the crops are not: the wide views carry
           enough pixels to fill it and are fitted down, while a narrow one
           like the folded front does not, and stretching it to the same width
           invents the difference. What that costs is exactly what this viewer
           is for — the model and colour code printed along the temple. So a
           crop smaller than the stage is shown at its own size instead: a
           smaller panel, centred on the scrim like any other, and sharp.

           The ceiling is device pixels rather than CSS pixels. On a 2x screen
           one CSS pixel is two real ones, so holding k at 1 there still paints
           each source pixel twice; 1:1 is half a CSS pixel per source pixel,
           which is 1/dpr. Magnifying is a deliberate act and may go past this
           — scaleFor() reads the same crop — but the view arrived at never
           does. */
        var dpr = window.devicePixelRatio;
        if (!(dpr > 0)) dpr = 1;
        var k = Math.min(sw / cw, sh / ch, 1 / dpr);
        cropSrcW = cw;
        zFrame.style.width = (cw * k).toFixed(1) + 'px';
        zFrame.style.height = (ch * k).toFixed(1) + 'px';
        zImg.style.width = (nw * k).toFixed(1) + 'px';
        zImg.style.height = (nh * k).toFixed(1) + 'px';
        zImg.style.left = (-c.x0 * k).toFixed(1) + 'px';
        zImg.style.top = (-c.y0 * k).toFixed(1) + 'px';
        if (!magnified) baseRect = zFrame.getBoundingClientRect();
      }

      /* ---- the colourway on screen, straight from the live thumb row ----
         Liquid states the 1920 rendition outright; the rows the variant picker
         rebuilds carry the 1100 only, so the width is rewritten instead. Both
         routes end at the same CDN URL. */
      function readItems(gallery) {
        var list = [];
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
          var display = t.getAttribute('data-src');
          list.push({
            full: t.getAttribute('data-zoom-src') || atWidth(display, 1920),
            thumb: atWidth(display, 160),
            display: display,
            alt: t.getAttribute('data-alt') || ''
          });
        });
        if (!list.length) {
          /* single-image product: the thumb row is never built */
          var solo = gallery.querySelector('[data-main-image]');
          if (solo) {
            var src = solo.getAttribute('src');
            list.push({ full: atWidth(src, 1920), thumb: atWidth(src, 160), display: src, alt: solo.alt || '' });
          }
        }
        return list;
      }

      function startIndex(gallery) {
        var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].classList.contains('is-active')) return i;
        }
        var main = gallery.querySelector('[data-main-image]');
        var want = fileOf(main && (main.currentSrc || main.src));
        if (want) {
          for (var j = 0; j < thumbs.length; j++) {
            if (fileOf(thumbs[j].getAttribute('data-src')) === want) return j;
          }
        }
        return 0;
      }

      /* ---- magnification ----
         Panning moves transform-origin rather than translating the window: the
         point under the pointer stays where it is, and the reachable area is
         exactly the crop, so no clamping arithmetic is needed. */
      function setOrigin(x, y) {
        zFrame.style.transformOrigin = (clamp01(x) * 100).toFixed(3) + '% ' + (clamp01(y) * 100).toFixed(3) + '%';
      }
      function queuePan() {
        if (panFrame) return;
        panFrame = requestAnimationFrame(function () { panFrame = 0; setOrigin(panX, panY); });
      }
      function captureBase() {
        if (!magnified) baseRect = zFrame.getBoundingClientRect();
      }
      function scaleFor() {
        var rect = baseRect || zFrame.getBoundingClientRect();
        /* the crop is what the shopper is looking at, so it sets the ceiling */
        var natural = cropSrcW || zImg.naturalWidth || 1920;
        if (!rect.width) return 2;
        var s = natural / rect.width;      /* one source pixel per screen pixel */
        if (s < 1.6) s = 1.6;              /* always worth the gesture */
        if (s > 3.2) s = 3.2;
        return Math.round(s * 100) / 100;
      }
      function magnify(x, y) {
        captureBase();
        if (!baseRect || !baseRect.width) return;
        magnified = true;
        scale = scaleFor();
        panX = clamp01(x); panY = clamp01(y);
        zoomRoot.classList.add('is-magnified');
        setOrigin(panX, panY);
        paint();
        if (zToggle) zToggle.setAttribute('aria-pressed', 'true');
        if (zToggleLabel) zToggleLabel.textContent = 'Fit';
      }
      function demagnify() {
        magnified = false;
        dragging = false;
        scale = 1;
        zoomRoot.classList.remove('is-magnified');
        paint();
        zFrame.style.transformOrigin = '50% 50%';
        if (zToggle) zToggle.setAttribute('aria-pressed', 'false');
        if (zToggleLabel) zToggleLabel.textContent = 'Magnify';
      }

      /* ---- frames ---- */
      function paintThumbs() {
        zThumbs.textContent = '';
        items.forEach(function (item, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('data-zoom-thumb', String(i));
          b.setAttribute('aria-label', 'View image ' + (i + 1));
          if (i === index) b.className = 'is-active';
          var im = document.createElement('img');
          im.src = item.thumb;
          im.alt = '';
          im.width = 64; im.height = 64;
          im.loading = 'lazy';
          b.appendChild(im);
          zThumbs.appendChild(b);
        });
        zThumbs.hidden = items.length < 2;
      }

      function show(i) {
        if (!items.length) return;
        index = (i % items.length + items.length) % items.length;
        demagnify();
        baseRect = null;
        zoomRoot.classList.add('is-loading');
        zImg.src = items[index].full;
        zImg.alt = items[index].alt;
        if (zCount) zCount.textContent = (index + 1) + ' / ' + items.length;
        zThumbs.querySelectorAll('button').forEach(function (b, n) {
          b.classList.toggle('is-active', n === index);
        });
        var solo = items.length < 2;
        if (zPrev) zPrev.hidden = solo;
        if (zNext) zNext.hidden = solo;
        /* re-showing the shot already on the stage assigns the src it holds, so
           a load event may never follow and the crop has to be asked for */
        if (zImg.complete && zImg.naturalWidth) {
          zoomRoot.classList.remove('is-loading');
          recrop();
        }
      }

      zImg.addEventListener('load', function () {
        zoomRoot.classList.remove('is-loading');
        recrop();
      });

      /* bvo.js owns the measurement and its cache; the viewer only asks for the
         box. Laying out first and again on the answer is deliberate: an asset
         still being measured — or one that can never be, because reading the
         pixels back failed — shows whole and centred rather than not at all. */
      var optical = (window.BVO && window.BVO.optical) || null;
      function recrop() {
        layout();
        var key = keyOf(zImg.currentSrc || zImg.src);
        if (!optical || !key || Object.prototype.hasOwnProperty.call(boxes, key)) return;
        optical.measure(zImg.currentSrc || zImg.src).then(function (box) {
          boxes[key] = box || null;
          if (keyOf(zImg.currentSrc || zImg.src) === key) layout();
        })['catch'](function () {
          boxes[key] = null;
          layout();
        });
      }

      /* ---- open / close ---- */
      function focusables() {
        return Array.prototype.filter.call(
          zDialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
          function (el) { return !el.disabled && !el.hidden && el.getClientRects().length > 0; }
        );
      }

      function open(gallery, trigger) {
        items = readItems(gallery);
        if (!items.length) return;
        opener = trigger || null;
        index = startIndex(gallery);

        /* every view measured up front, off one 512px probe each: stepping
           through the strip then finds its crop in the cache and lands on the
           first frame, instead of showing whole and snapping a moment later */
        if (optical) items.forEach(function (item) { optical.measure(item.full); });

        /* hold the page still: overflow alone keeps the scroll position, and the
           gutter is replaced so the layout behind the scrim does not jump */
        var gutter = window.innerWidth - document.documentElement.clientWidth;
        if (gutter > 0) { document.body.style.paddingRight = gutter + 'px'; padded = true; }
        document.body.classList.add('zoom-open');

        zoomRoot.hidden = false;
        zoomRoot.setAttribute('aria-hidden', 'false');
        paintThumbs();
        show(index);
        if (zClose) zClose.focus();
        document.addEventListener('keydown', onKey, true);
      }

      function close() {
        if (zoomRoot.hidden) return;
        demagnify();
        document.removeEventListener('keydown', onKey, true);
        zoomRoot.hidden = true;
        zoomRoot.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('zoom-open');
        if (padded) { document.body.style.paddingRight = ''; padded = false; }
        if (opener && opener.focus) opener.focus();
        opener = null;
      }

      function onKey(event) {
        if (zoomRoot.hidden) return;
        if (event.key === 'Escape') { event.preventDefault(); close(); return; }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); return; }
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); return; }
        if (event.key !== 'Tab') return;
        var nodes = focusables();
        if (!nodes.length) return;
        var first = nodes[0], last = nodes[nodes.length - 1];
        if (!zDialog.contains(document.activeElement)) { event.preventDefault(); first.focus(); return; }
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }

      /* ---- pointer ---- */
      zStage.addEventListener('pointerdown', function (event) {
        if (!magnified || event.pointerType === 'mouse' || event.isPrimary === false) return;
        dragging = true; dragMoved = false;
        lastX = event.clientX; lastY = event.clientY;
        try { zStage.setPointerCapture(event.pointerId); } catch (e) {}
      });

      zStage.addEventListener('pointermove', function (event) {
        if (!magnified || !baseRect || !baseRect.width) return;
        if (event.pointerType === 'mouse') {
          panX = clamp01((event.clientX - baseRect.left) / baseRect.width);
          panY = clamp01((event.clientY - baseRect.top) / baseRect.height);
          queuePan();
          return;
        }
        if (!dragging || scale <= 1) return;
        var dx = event.clientX - lastX;
        var dy = event.clientY - lastY;
        if (Math.abs(dx) + Math.abs(dy) > 3) dragMoved = true;
        lastX = event.clientX; lastY = event.clientY;
        /* the origin runs against the drag so the image follows the finger */
        panX = clamp01(panX - dx / (baseRect.width * (scale - 1)));
        panY = clamp01(panY - dy / (baseRect.height * (scale - 1)));
        queuePan();
      });

      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (type) {
        zStage.addEventListener(type, function (event) {
          if (!dragging) return;
          dragging = false;
          try { zStage.releasePointerCapture(event.pointerId); } catch (e) {}
        });
      });

      /* ---- clicks ----
         on the window rather than the image: the margin the crop added is part
         of the panel, and clicking it should magnify like the rest of it */
      zFrame.addEventListener('click', function (event) {
        if (dragMoved) { dragMoved = false; return; }
        if (magnified) { demagnify(); return; }
        var rect = zFrame.getBoundingClientRect();
        magnify(
          rect.width ? (event.clientX - rect.left) / rect.width : 0.5,
          rect.height ? (event.clientY - rect.top) / rect.height : 0.5
        );
      });

      zStage.addEventListener('click', function (event) {
        if (event.target === zStage) close();          /* the scrim around the panel */
      });
      if (zScrim) zScrim.addEventListener('click', close);
      if (zClose) zClose.addEventListener('click', close);
      if (zPrev) zPrev.addEventListener('click', function () { show(index - 1); });
      if (zNext) zNext.addEventListener('click', function () { show(index + 1); });
      if (zToggle) zToggle.addEventListener('click', function () {
        if (magnified) demagnify(); else magnify(0.5, 0.5);
      });

      zThumbs.addEventListener('click', function (event) {
        var b = event.target.closest ? event.target.closest('[data-zoom-thumb]') : null;
        if (!b || !zThumbs.contains(b)) return;
        show(parseInt(b.getAttribute('data-zoom-thumb'), 10));
      });

      /* a resize changes the stage the crop was fitted to, and invalidates the
         geometry the magnification was measured from */
      window.addEventListener('resize', function () {
        if (magnified) demagnify();
        baseRect = null;
        layout();
      });

      document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
        gallery.addEventListener('click', function (event) {
          var trigger = event.target.closest ? event.target.closest('[data-zoom-open]') : null;
          if (!trigger || !gallery.contains(trigger)) return;
          event.preventDefault();
          open(gallery, trigger);
        });
      });
    }
  });
})();
